import { localHostBaseURL } from '../../../../helpers/domainURL';
import requestUtil from '../../../../helpers/requestUtil';
import { setLoading } from '../../../common/Loader/slice';
import * as Toasts from '../../../common/Toastify';
import { updateSharedSlice } from '../../../shared/sharedSlice';
import {
  resetError,
  resetParams,
  setCandidateSearchInfo,
  setDropdownJobId,
  setError,
  setFilterControls,
  setIsDataNotFound,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  setMasterData,
  setParams,
  setTotalCount,
  updateCertificationList,
  updateEducationLevelList,
  updateemrEhrExpInList,
  updateJobCategoryList,
  updateMasterData,
  updatePreferredShiftTimeOfTheDayList,
  updateSpecialityList,
} from './slice';

export const updateParams = (data) => {
  return async (dispatch) => {
    dispatch(setParams(data));
  };
};

export const resetParamVal = () => {
  return async (dispatch) => {
    dispatch(resetParams());
  };
};

export const getCandidateSearchDetail = ({ url, params, formInfo }) => {
  const newparams = { ...params };
  newparams.locationId = params.locationId ? params.locationId : 0;
  newparams.distance = params.distance ? parseInt(params.distance) : 0;
  newparams.distanceId = params.distanceId ? params.distanceId : 0;
  newparams.status = params.status.map((item) => item.id);
  newparams.shifts = params.shifts.map((item) => item.id);
  newparams.specialities = params.specialities.map((item) => item.id);
  newparams.emrehrSystem = params.emrehrSystem.map((item) => item.id);
  newparams.positions = params.positions.map((item) => item.id);
  newparams.certifications = params.certifications.map((item) => item.id);
  newparams.education = params.education.map((item) => item.id);
  newparams.covid19Vaccinated = params.covid19Vaccinated.map((item) => item.id);
  newparams.jobTypeid = params.jobTypeid ? params.jobTypeid : 0;
  newparams.spokenLanguages = params.spokenLanguages.map((item) => item.id);
  newparams.JobTypeIdList = params.JobTypeIdList.map((item) => item.id);
  newparams.PreferredShiftTimeOfTheDays = params.PreferredShiftTimeOfTheDays.map((item) => item.id);
  newparams.department = params.department.map((item) => item.id);
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    // Employers/search-candidates-optimized
    // Employers/old-search-candidates-optimized
    try {
      const response = await requestUtil(`${url}/Employers/search-candidates-optimized`, 'POST', {
        ...newparams,
        formInfo,
      });
      formartData(response.candidateSearchList);
      dispatch(setCandidateSearchInfo(response.candidateSearchList));
      dispatch(setTotalCount(response.totalCount));
      if(response?.candidateSearchList?.length === 0){
        dispatch(setIsDataNotFound(true))
      } else {
        dispatch(setIsDataNotFound(false))
      }
    } catch (error) {
      dispatch(setError(error.message));
      dispatch(setIsDataNotFound(false))
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const loadMasterData = (baseUrl, empuniqueId, dropId) => {
  return async (dispatch,getState) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());
    const state = getState();
    const locationSharedList = state.shared.locationSharedList;
    const distanceSharedList = state.shared.distanceSharedList;
    const covidVaccineSharedList = state.shared.covidVaccineSharedList;
    const spokenLanguageSharedList = state.shared.covidVaccineSharedList;
    const statusSharedList = state.shared.statusSharedList;
    const preferredShiftSharedList = state.shared.preferredShiftSharedList;
    const preferredShiftTimeSharedList = state.shared.preferredShiftTimeSharedList;
    let location = locationSharedList ?? [];
    let travelDistance = distanceSharedList ?? [];
    let covid = covidVaccineSharedList ?? [];
    let spokenLanguages = spokenLanguageSharedList ?? [];
    let status = statusSharedList ?? [];
    let newstatus = statusSharedList?.length > 0 ?  statusSharedList?.filter(status => status?.name?.toLowerCase() !== "all") : [] 
    let shift = preferredShiftSharedList ?? [];
    let PreferredShiftTimeOfTheDay = preferredShiftTimeSharedList ?? [];
    const params = state.searchWithCriteriaInfoV2.params;
    let jobTypeIdList = [];
    try {
      // const jobtype = await requestUtil(`${baseUrl}/Dropdown/getjobtype`, 'GET');
      const jobtype = await requestUtil(
        `${baseUrl}/Employers/getjobtypes/${empuniqueId}`,
        'POST',
        {}
      );
      if(params?.JobTypeIdList?.length > 0){
        jobTypeIdList = params?.JobTypeIdList;
     } else {
       jobTypeIdList = jobtype
     }
     if(location.length === 0){
      location = await requestUtil(`${baseUrl}/Locations/get-location-list-for-dropdown/${empuniqueId}`,'GET');
      dispatch(updateSharedSlice({name:"locationSharedList",value:location}));
     }
     if(status?.length === 0){
      status = await requestUtil(`${baseUrl}/Dropdown/get-candidate-status-for-employer-search`, 'GET');
      newstatus =  status?.filter(st => st?.name?.toLowerCase() !== "all") 
      dispatch(updateSharedSlice({name:"statusSharedList",value:status}));
  } 
      // const job = await requestUtil(
      //   `${baseUrl}/Dropdown/getjobcategories/${dropId}`,
      //   'GET'
      // );

      const job = await requestUtil(
        `${baseUrl}/Employers/get-job-categories`,
        'POST',
        jobTypeIdList?.length ? { jobtypes: jobTypeIdList.map(item => item.id) } : { jobtypes: [] }
      );


      // const medical = await requestUtil(
      //   `${baseUrl}/Dropdown/getspecialties/${dropId}`,
      //   'GET'
      // );
      // const medical = await requestUtil(
      //   `${baseUrl}/Employers/get-specialties`,
      //   'POST',
      //   jobtype?.length ? { jobtypes: jobtype.map(item => item.id) } : { jobtypes: [] }
      // );
      // const certifcation = await requestUtil(
      //   `${baseUrl}/Dropdown/getcertifications/${dropId}`,
      //   'GET'
      // );
      // const certifcation = await requestUtil(
      //   `${baseUrl}/Employers/get-certifications`,
      //   'POST',
      //   jobtype?.length ? { jobtypes: jobtype.map(item => item.id) } : { jobtypes: [] }
      // );

      // const emrehr = await requestUtil(
      //   `${baseUrl}/Dropdown/getemrehrsystems/${dropId}`,
      //   'GET'
      // );
      // const emrehr = await requestUtil(
      //   `${baseUrl}/Employers/get-emrehrsystems`,
      //   'POST',
      //   jobtype?.length ? { jobtypes: jobtype.map(item => item.id) } : { jobtypes: [] }
      // );
      // const education = await requestUtil(
      //   `${baseUrl}/Dropdown/GetLevelOfEducationsV2/${dropId}`,
      //   'GET'
      // );
      const education = await requestUtil(
        `${baseUrl}/Employers/get-levelof-educations`,
        'POST',
        jobTypeIdList?.length ? { jobtypes: jobTypeIdList.map(item => item.id) } : { jobtypes: [] }
      );
      if(covid?.length === 0){
        covid = await requestUtil(`${baseUrl}/Dropdown/GetCovidvaccinated`,'GET');
        dispatch(updateSharedSlice({name:"covidVaccineSharedList",value:covid}));
      }
      if(shift?.length === 0){
         shift = await requestUtil(`${baseUrl}/Dropdown/GetPreferredShifts`,'GET');
        dispatch(updateSharedSlice({name:"preferredShiftSharedList",value:shift}));
      }
      // const newstatus = await requestUtil(
      //   `${baseUrl}/Dropdown/get-candidate-status-for-employer-status-update-dropdown`,
      //   'GET'
      // );
      if(travelDistance?.length === 0){
         travelDistance = await requestUtil(`${baseUrl}/Dropdown/GetTravelDistances`,'GET');
        dispatch(updateSharedSlice({name:"distanceSharedList",value:travelDistance}));

      }
      if(spokenLanguages?.length === 0){
        spokenLanguages = await requestUtil(`${baseUrl}/Dropdown/GetSpokenLanguages`,'GET');
        dispatch(updateSharedSlice({name:"spokenLanguageSharedList",value:spokenLanguages}));
      }
      if(PreferredShiftTimeOfTheDay?.length === 0){
         PreferredShiftTimeOfTheDay = await requestUtil(`${baseUrl}/Dropdown/GetPreferredShiftTimeOfTheDaysList`,'GET');
        dispatch(updateSharedSlice({name:"preferredShiftTimeSharedList",value:PreferredShiftTimeOfTheDay}));
      }

      const depsUnits = await requestUtil(`${baseUrl}/Departments/get-active-department-details-with-Any`, 'GET');
      const depsUnitsMaster = depsUnits?.departmentList?.length ? depsUnits?.departmentList?.map(item => ({ name: item?.departmentName, id: item?.candidateDepartmentId })) : [];
      dispatch(updateMasterData({ name: "depsUnitsMaster", value: depsUnitsMaster }));

      dispatch(
        setMasterData({
          location,
          status,
          job: groupByDropDownFormat(
            job.groupedOption
            ),
            education: groupByDropDownFormat(
              education.groupedOption
            ),
          // medical: groupByDropDownFormat(
          //   medical.groupedOption
          // ),
          // certifcation: groupByDropDownFormat(
          //   certifcation.groupedOption
          // ),
          // emrehr: groupByDropDownFormat(
          //   emrehr.groupedOption
          // ),
          covid,
          shift,
          newstatus,
          travelDistance,
          jobtype,
          spokenLanguages,
          PreferredShiftTimeOfTheDay
        })
      );
      if( params?.positions?.length ){
        const jobLevelParams = {
          jobLevel: params?.positions?.length ? params?.positions?.map(item => item?.id) : []
        }
        // console.log({jobLevelParams,params});
        dispatch(loadMasterDataBasedonJobLevel({ url:baseUrl, jobLevelParams }))
      }
      // dispatch(setLoading(false));
    } catch (error) {
      // dispatch(setLoading(false));
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

const formartData = (data) => {
  data.map((item) => {
    item.shiftsCompleted = item.shiftsCompleted
      ? `${item.shiftsCompleted} Shifts`
      : '';
    item.hoursWorked = item.hoursWorked ? `${item.hoursWorked} Hours` : '';
    item.distance = `${item.distance} miles`;
  });
};

export const updateStatus = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      Toasts.success(response.message);
      return response?.result ? true : false;
    } catch (error) {
      dispatch(setError(error.message));
      Toasts.error(error.message);
      return false;
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const saveFavorite = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      Toasts.success(response.message);
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateDropDownJobId = (id) => {
  //console.log('--------2------');
  return async (dispatch) => {
    dispatch(setDropdownJobId(id));
  };
};

export const getFormControls = ({ url, jobLevel }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { jobLevel });
      // console.log(response);
      if (response?.formInfo) {
        dispatch(setFilterControls(response?.formInfo));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const updateDynamicFilterDetail = (data) => {
  return async (dispatch) => {
    dispatch(setFilterControls(data));
  };
};
export function updateJobCategoryMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const jobList = await requestUtil(
        `${url}/Dropdown/getjobcategories/${value}`,
        'GET'
      );
      dispatch(updateJobCategoryList(jobList));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updateEducationLevelMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Dropdown/GetLevelOfEducationsV2/${value}`,
        'GET'
      );
      dispatch(updateEducationLevelList(educationLevelList));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function updateJobSpecialityMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const specialityList = await requestUtil(
        `${url}/Dropdown/getspecialties/${value}`,
        'GET'
      );
      dispatch(updateSpecialityList(specialityList));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updateJobemrEhrSystemExpInMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const emrEhrExp = await requestUtil(
        `${url}/Dropdown/getemrehrsystems/${value}`,
        'GET'
      );
      dispatch(updateemrEhrExpInList(emrEhrExp));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updateJobCertificationMasterData(url, field, value) {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const certification = await requestUtil(
        `${url}/Dropdown/getcertifications/${value}`,
        'GET'
      );
      dispatch(updateCertificationList(certification));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getLevelOfEducations(url, requestBody) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Employers/get-levelof-educations`,
        'POST',
        requestBody
      );
      const groupByDropDownResult = groupByDropDownFormat(
        educationLevelList.groupedOption
      );
      dispatch(updateEducationLevelList(groupByDropDownResult));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getJobCategories(url, requestBody) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Employers/get-job-categories`,
        'POST',
        requestBody
      );
      const groupByDropDownResult = groupByDropDownFormat(
        educationLevelList.groupedOption
      );
      dispatch(updateJobCategoryList(groupByDropDownResult));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getEmrehrsystems(url, requestBody) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Employers/get-emrehrsystems`,
        'POST',
        requestBody
      );
      const groupByDropDownResult = groupByDropDownFormat(
        educationLevelList.groupedOption
      );
      dispatch(updateemrEhrExpInList(groupByDropDownResult));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getSpecialties(url, requestBody) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Employers/get-specialties`,
        'POST',
        requestBody
      );
      const groupByDropDownResult = groupByDropDownFormat(
        educationLevelList.groupedOption
      );
      dispatch(updateSpecialityList(groupByDropDownResult));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getCertifications(url, requestBody) {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const educationLevelList = await requestUtil(
        `${url}/Employers/get-certifications`,
        'POST',
        requestBody
      );
      const groupByDropDownResult = groupByDropDownFormat(
        educationLevelList.groupedOption
      );
      dispatch(updateCertificationList(groupByDropDownResult));
    } catch (error) {
      // dispatch(setFailureLogs(error.message))
      dispatch(setError(error.message));
      // console.log(error);
    } finally {
      // dispatch(setLoading(false));
      dispatch(setLoadingFlagDecrement());
    }
  };
}

function groupByDropDownFormat(requestArray) {
  const newArray = [];
  if (requestArray && requestArray.length) {
    for (let index = 0; index < requestArray.length; index++) {
      const element = requestArray[index];
      const groupByLabel = element.label;
      const newOptions = element.options.map((e) => {
        return {
          ...e,
          groupByLabel,
        };
      });
      newArray.push(...newOptions);
    }
  }
  return newArray;
}

export function sendEmail({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Email sent successfully!");
      return response;
    } catch (error) {
      Toasts.error("Email not sent!");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function sendSMS({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Sms sent successfully!");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function getEmailDetails({ url }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "GET");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function getSMSDetails({ url,params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST",{...params});
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(url);
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}


export function sendAllSmsbtn(url) {
  return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
          const response = await requestUtil(url);
          return response;
      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
      }
  };
}


export const loadMasterDataBasedonJobLevel = ({url,jobLevelParams}) => {
  // console.log({url,jobLevelParams});
  return async(dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try{
      const emrEhrSystemExp = await requestUtil(
        `${url}/Dropdown/Get-New-EMREHRSystems-byJobLevel`,
        'POST',{...jobLevelParams}
      );
      const certifications = await requestUtil(
        `${url}/Dropdown/Get-New-Certifications-byJobLevel`,
        'POST',{...jobLevelParams}
      );
      const specialities = await requestUtil(
        `${url}/Dropdown/Get-New-Specialties-byJobLevel`,
        'POST',{...jobLevelParams}
      );
      dispatch(updateSpecialityList(specialities))
      dispatch(updateemrEhrExpInList(emrEhrSystemExp))
      dispatch(updateCertificationList(certifications))
    } catch(error){
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

export function getCallHistory(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Voice/get-recordings`,
        'POST', params
      );;
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export const exportDetailsToExcel = ({baseUrl,params,formInfo}) => {
  const newparams = { ...params,formInfo };
  newparams.locationId = params.locationId ? params.locationId : 0;
  newparams.distance = params.distance ? parseInt(params.distance) : 0;
  newparams.distanceId = params.distanceId ? params.distanceId : 0;
  newparams.status = params.status.map((item) => item.id);
  newparams.shifts = params.shifts.map((item) => item.id);
  newparams.specialities = params.specialities.map((item) => item.id);
  newparams.emrehrSystem = params.emrehrSystem.map((item) => item.id);
  newparams.positions = params.positions.map((item) => item.id);
  newparams.certifications = params.certifications.map((item) => item.id);
  newparams.education = params.education.map((item) => item.id);
  newparams.covid19Vaccinated = params.covid19Vaccinated.map((item) => item.id);
  newparams.jobTypeid = params.jobTypeid ? params.jobTypeid : 0;
  newparams.spokenLanguages = params.spokenLanguages.map((item) => item.id);
  newparams.JobTypeIdList = params.JobTypeIdList.map((item) => item.id);
  newparams.PreferredShiftTimeOfTheDays = params.PreferredShiftTimeOfTheDays.map((item) => item.id);
  newparams.department = params.department.map((item) => item.id);
  newparams.pageSize = 0;
  const login = JSON.parse(sessionStorage.getItem('login'));
  const  accessToken = login.accessToken;
  return async(dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
        const requestHeaders = {
          'Content-Type': 'application/json',
          'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Authorization': accessToken ? `Bearer ${accessToken}` : '',
          'Website-Domain-Name': window.location.hostname === 'localhost' ? localHostBaseURL : window.location.hostname,
      };
       const result = await fetch(`${baseUrl}/Employers/export-candidates-search`, {
            headers:{...requestHeaders},
            method:"POST",
            body:JSON.stringify(newparams)
        })
        const data = await result.blob();
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'candidate_list.xlsx';
        a.click();

              // Cleanup
        window.URL.revokeObjectURL(url);
         document.body.removeChild(a);

      } catch (error) {
          return error.message;
      } finally {
          dispatch(setLoadingFlagDecrement());
        }
  }
}

export const fetchDollarDetails = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const result = await requestUtil(url, "POST", { ...params });
      if (result?.result) {
        return result?.candidatePayRateSetupList
      }
    } catch (error) {
      return error
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}
